import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import { MenuTypes } from "@dp/services";
import { toFloat, toInteger, toStringArray } from "@dp/common";
import SKU from "./SKU";
import moment from "moment-timezone";
var MenuItemDetail = (_dec = observable.shallow, _dec2 = observable.ref, (_class = /*#__PURE__*/function () {
  function MenuItemDetail(rawMenuDetailAPIResponse) {
    _classCallCheck(this, MenuItemDetail);

    _initializerDefineProperty(this, "_skus", _descriptor, this);

    _initializerDefineProperty(this, "_data", _descriptor2, this);

    makeObservable(this);
    this.setRawMenuDetailAPIResponse(rawMenuDetailAPIResponse);
  }

  _createClass(MenuItemDetail, [{
    key: "markDirty",
    value: function markDirty() {
      var _this$selectedSKU, _this$selectedSKU$opt;

      (_this$selectedSKU = this.selectedSKU) === null || _this$selectedSKU === void 0 ? void 0 : (_this$selectedSKU$opt = _this$selectedSKU.options) === null || _this$selectedSKU$opt === void 0 ? void 0 : _this$selectedSKU$opt.forEach(function (configProperty) {
        if (configProperty) {
          configProperty === null || configProperty === void 0 ? void 0 : configProperty.setIsDirty(true, true);
        }
      });
    }
  }, {
    key: "processSKUEntries",
    value: function processSKUEntries() {
      var _this = this;

      this._skus = this.filteredMenuSkuBeansWithoutPrice.map(function (rawMenuBean) {
        return new SKU(rawMenuBean, _this);
      });
      var filtered = [];

      if (this.defaultSelectedSku) {
        filtered = this._skus.filter(function (sku) {
          return sku.optionId === _this.defaultSelectedSku;
        });
      }

      var sku2Sel = filtered.length > 0 ? filtered[0] : this._skus.length > 1 ? null : this._skus[0];

      if (sku2Sel) {
        sku2Sel.selected = true;
      }
    }
  }, {
    key: "clearTree",
    value: function clearTree() {
      var _this$_skus;

      var ignoreOptionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      (_this$_skus = this._skus) === null || _this$_skus === void 0 ? void 0 : _this$_skus.forEach(function (opt) {
        if (ignoreOptionIds.indexOf(opt.optionId) < 0) {
          opt.clearTree();
        }
      });
    }
  }, {
    key: "setRawMenuDetailAPIResponse",
    value: function setRawMenuDetailAPIResponse(rawMenuDetailAPIResponse) {
      var _this2 = this;

      runInAction(function () {
        _this2._data = rawMenuDetailAPIResponse;
      });
      this.processSKUEntries();
    }
  }, {
    key: "findSKU",
    value: function findSKU(optionId) {
      var _this$_skus2;

      var sku = null;
      (_this$_skus2 = this._skus) === null || _this$_skus2 === void 0 ? void 0 : _this$_skus2.forEach(function (tSku) {
        if (tSku.optionId === optionId) {
          sku = tSku;
        }
      });
      return sku;
    }
  }, {
    key: "findSelectionTreeForOptionBySelectedId",
    value: function findSelectionTreeForOptionBySelectedId(selectedId) {
      var _this$_skus3;

      var nodes = [];
      (_this$_skus3 = this._skus) === null || _this$_skus3 === void 0 ? void 0 : _this$_skus3.forEach(function (sku) {
        var propNodes = sku.findSelectionTreeForOptionBySelectedId(selectedId);

        if (propNodes.length > 0) {
          nodes.push.apply(nodes, _toConsumableArray(propNodes));
        }
      });
      return nodes;
    }
  }, {
    key: "options",
    get: function get() {
      return this._skus;
    }
  }, {
    key: "pretty",
    get: function get() {
      return {
        isInValid: this.isInValid,
        isMultiSku: this.isMultiSku,
        id: this.id,
        name: this.name,
        displayPrice: this.displayPrice,
        price: this.price,
        defaultSelectedSku: this.defaultSelectedSku,
        description: this.description,
        longDescription: this.longDescription,
        isToGo: this.isToGo,
        isComplex: this.isComplex,
        sku: this.selectedSKU ? this.selectedSKU.pretty : null
      };
    }
  }, {
    key: "isInValid",
    get: function get() {
      return this.selectedSKU ? this.selectedSKU.isInValid : true;
    }
  }, {
    key: "isMultiSku",
    get: function get() {
      var _this$price;

      return ((_this$price = this.price) === null || _this$price === void 0 ? void 0 : _this$price.length) > 1 ? true : false;
    }
  }, {
    key: "selectedSKU",
    get: function get() {
      var filtered = this._skus.filter(function (sku) {
        return sku.selected;
      });

      return filtered.length === 1 ? filtered[0] : null;
    }
  }, {
    key: "id",
    get: function get() {
      var _this$_data;

      var successResponse = (_this$_data = this._data) === null || _this$_data === void 0 ? void 0 : _this$_data.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.repositoryId;
    }
  }, {
    key: "keywords",
    get: function get() {
      var _this$_data2;

      var successResponse = (_this$_data2 = this._data) === null || _this$_data2 === void 0 ? void 0 : _this$_data2.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.keywords;
    }
  }, {
    key: "imageURL",
    get: function get() {
      var _this$_data3;

      var successResponse = (_this$_data3 = this._data) === null || _this$_data3 === void 0 ? void 0 : _this$_data3.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.largeImageUrl;
    }
  }, {
    key: "mobileAppSmallImage",
    get: function get() {
      var _this$_data4;

      var successResponse = (_this$_data4 = this._data) === null || _this$_data4 === void 0 ? void 0 : _this$_data4.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.mobileAppSmallImage;
    }
  }, {
    key: "mobileAppLargeImage",
    get: function get() {
      var _this$_data5;

      var successResponse = (_this$_data5 = this._data) === null || _this$_data5 === void 0 ? void 0 : _this$_data5.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.mobileAppLargeImage;
    }
  }, {
    key: "hasLunchPortion",
    get: function get() {
      var _this$_data6;

      var successResponse = (_this$_data6 = this._data) === null || _this$_data6 === void 0 ? void 0 : _this$_data6.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.hasLunchPortion;
    }
  }, {
    key: "enableAppImageAnimation",
    get: function get() {
      var _this$_data7;

      var successResponse = (_this$_data7 = this._data) === null || _this$_data7 === void 0 ? void 0 : _this$_data7.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.requiresAppAnimation;
    }
  }, {
    key: "name",
    get: function get() {
      var _this$_data8;

      var successResponse = (_this$_data8 = this._data) === null || _this$_data8 === void 0 ? void 0 : _this$_data8.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.displayName;
    }
  }, {
    key: "description",
    get: function get() {
      var _this$_data9;

      var successResponse = (_this$_data9 = this._data) === null || _this$_data9 === void 0 ? void 0 : _this$_data9.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.description;
    } //TODO Change this

  }, {
    key: "defaultSelectedSku",
    get: function get() {
      var _this$_data10;

      var successResponse = (_this$_data10 = this._data) === null || _this$_data10 === void 0 ? void 0 : _this$_data10.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.defaultSelectedSku;
    }
  }, {
    key: "longDescription",
    get: function get() {
      var _this$_data11, _successResponse$loca, _successResponse$loca2;

      var successResponse = (_this$_data11 = this._data) === null || _this$_data11 === void 0 ? void 0 : _this$_data11.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return (_successResponse$loca = successResponse.locationSpecificDescriptionInfo) !== null && _successResponse$loca !== void 0 && _successResponse$loca.longDescription ? (_successResponse$loca2 = successResponse.locationSpecificDescriptionInfo) === null || _successResponse$loca2 === void 0 ? void 0 : _successResponse$loca2.longDescription : product === null || product === void 0 ? void 0 : product.longDescription;
    }
  }, {
    key: "legalDisclaimer",
    get: function get() {
      var _this$_data12, _successResponse$loca3;

      var successResponse = (_this$_data12 = this._data) === null || _this$_data12 === void 0 ? void 0 : _this$_data12.successResponse;
      return successResponse === null || successResponse === void 0 ? void 0 : (_successResponse$loca3 = successResponse.locationSpecificDescriptionInfo) === null || _successResponse$loca3 === void 0 ? void 0 : _successResponse$loca3.legalDisclaimer;
    }
  }, {
    key: "price",
    get: function get() {
      var _this$_data13;

      var successResponse = (_this$_data13 = this._data) === null || _this$_data13 === void 0 ? void 0 : _this$_data13.successResponse;
      var price = successResponse === null || successResponse === void 0 ? void 0 : successResponse.price;
      var productPrice = price === null || price === void 0 ? void 0 : price.map(function (priceElement) {
        return {
          skuId: priceElement.skuId,
          price: priceElement.listPrice
        };
      });
      return productPrice;
    }
  }, {
    key: "skuPriceMap",
    get: function get() {
      var _this$price2;

      return ((_this$price2 = this.price) === null || _this$price2 === void 0 ? void 0 : _this$price2.length) > 0 ? this.price.reduce(function (res, priceItem) {
        res[priceItem.skuId] = {
          price: priceItem.price,
          skuId: priceItem.skuId
        };
        return res;
      }, {}) : null;
    }
  }, {
    key: "lowestPrice",
    get: function get() {
      var _this$price3,
          _this3 = this;

      return (_this$price3 = this.price) === null || _this$price3 === void 0 ? void 0 : _this$price3.reduce(function (lowestPrice, priceItem) {
        if (lowestPrice) {
          lowestPrice = priceItem.price ? lowestPrice.price > priceItem.price ? priceItem : lowestPrice : lowestPrice;
        } else {
          var _this3$price;

          lowestPrice = priceItem !== null && priceItem !== void 0 && priceItem.price ? priceItem : ((_this3$price = _this3.price) === null || _this3$price === void 0 ? void 0 : _this3$price.length) === 1 && (priceItem === null || priceItem === void 0 ? void 0 : priceItem.price) === 0 ? priceItem : lowestPrice;
        }

        return lowestPrice;
      }, null);
    }
    /*@computed public get displayPrice(): MenuTypes.IPrice {
      const ret = this.catalogRefId
        ? this.skuPriceMap[this.catalogRefId]
        : this.lowestPrice;
      return ret ? ret : this.lowestPrice;
    }*/

  }, {
    key: "displayPrice",
    get: function get() {
      return this.lowestPrice;
    }
  }, {
    key: "itemTotalPrice",
    get: function get() {
      if (this.selectedSKU) {
        return this.selectedSKU.itemTotalPrice;
      } else {
        var _this$displayPrice;

        return (_this$displayPrice = this.displayPrice) === null || _this$displayPrice === void 0 ? void 0 : _this$displayPrice.price;
      }
    }
  }, {
    key: "indicators",
    get: function get() {
      var _this$_data14;

      var successResponse = (_this$_data14 = this._data) === null || _this$_data14 === void 0 ? void 0 : _this$_data14.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      var indicators = product === null || product === void 0 ? void 0 : product.indicators;

      if (indicators && indicators.length > 0) {
        var today = moment().toDate();
        var currentTime = today.getTime();
        return indicators.filter(function (indicator) {
          var _indicator$effectiveD, _indicator$expiration;

          if ((_indicator$effectiveD = indicator.effectiveDate) !== null && _indicator$effectiveD !== void 0 && _indicator$effectiveD.time && currentTime < indicator.effectiveDate.time) {
            return false;
          }

          if ((_indicator$expiration = indicator.expirationDate) !== null && _indicator$expiration !== void 0 && _indicator$expiration.time && currentTime >= indicator.expirationDate.time) {
            return false;
          }

          return true;
        });
      } else {
        return indicators;
      }
    }
  }, {
    key: "isToGo",
    get: function get() {
      var _this$_data15;

      var successResponse = (_this$_data15 = this._data) === null || _this$_data15 === void 0 ? void 0 : _this$_data15.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.isToGo;
    }
  }, {
    key: "isDineInOnly",
    get: function get() {
      return !this.isToGo;
    }
  }, {
    key: "isComplex",
    get: function get() {
      var filteredMenuSkuBeansWithoutPrice = this.filteredMenuSkuBeansWithoutPrice;
      return filteredMenuSkuBeansWithoutPrice && filteredMenuSkuBeansWithoutPrice.length > 0;
    }
  }, {
    key: "filteredMenuSkuBeansWithoutPrice",
    get: function get() {
      var _this$_data16;

      var successResponse = (_this$_data16 = this._data) === null || _this$_data16 === void 0 ? void 0 : _this$_data16.successResponse;
      var price = successResponse.price;
      var menubean = successResponse === null || successResponse === void 0 ? void 0 : successResponse.menubean;
      return menubean === null || menubean === void 0 ? void 0 : menubean.filter(function (_mb) {
        return price === null || price === void 0 ? void 0 : price.find(function (_p) {
          var _mb$menuSkuBean;

          return _p.skuId === (_mb === null || _mb === void 0 ? void 0 : (_mb$menuSkuBean = _mb.menuSkuBean) === null || _mb$menuSkuBean === void 0 ? void 0 : _mb$menuSkuBean.id);
        });
      });
    }
  }, {
    key: "calories",
    get: function get() {
      var _this$_data17;

      var successResponse = (_this$_data17 = this._data) === null || _this$_data17 === void 0 ? void 0 : _this$_data17.successResponse;
      var nutritionaldetails = successResponse.nutritionaldetails;
      return toFloat(nutritionaldetails === null || nutritionaldetails === void 0 ? void 0 : nutritionaldetails.calValue);
    }
    /*@computed public get catalogRefId(): number {
      return this.filteredMenuSkuBeansWithoutPrice?.menuSkuBean?.repositoryItem
        ?.id;
    }*/

  }, {
    key: "greyOut",
    get: function get() {
      var _this$_data18;

      var successResponse = (_this$_data18 = this._data) === null || _this$_data18 === void 0 ? void 0 : _this$_data18.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.greyOut;
    }
  }, {
    key: "nutritionFacts",
    get: function get() {
      var _this$_data19;

      var successResponse = (_this$_data19 = this._data) === null || _this$_data19 === void 0 ? void 0 : _this$_data19.successResponse;
      var nutritionaldetails = successResponse === null || successResponse === void 0 ? void 0 : successResponse.nutritionaldetails;
      return nutritionaldetails === null || nutritionaldetails === void 0 ? void 0 : nutritionaldetails.map(function (nutritionaldetail) {
        var _nutritionaldetail$nu;

        var nutritions = (_nutritionaldetail$nu = nutritionaldetail.nutritionFactsList) === null || _nutritionaldetail$nu === void 0 ? void 0 : _nutritionaldetail$nu.map(function (nutritionFact) {
          var _nutritionFact$nutrit;

          var nutrients = (_nutritionFact$nutrit = nutritionFact.nutritionFacts) === null || _nutritionFact$nutrit === void 0 ? void 0 : _nutritionFact$nutrit.map(function (nutrientFact) {
            return {
              metric: nutrientFact.metricUOM,
              name: nutrientFact.metricName,
              value: toFloat(nutrientFact.roundedValue)
            };
          });
          return {
            name: nutritionFact.nutritionComponentName,
            nutrients: nutrients
          };
        });
        return {
          sku: nutritionaldetail.skuId,
          nutrientListOrder: nutritionaldetail.metricNameList,
          nutriCollections: nutritionaldetail.nutriCollections,
          nutritions: nutritions,
          showNutrition: nutritionaldetail.showNutrition,
          isNutritionDynamic: nutritionaldetail.isNutritionDynamic,
          nutritionalFDAMessage: nutritionaldetail.nutritionalFDAMessage,
          calories: toFloat(nutritionaldetail.calValue)
        };
      });
    }
  }, {
    key: "isCateringItem",
    get: function get() {
      var _this$_data20;

      return (_this$_data20 = this._data) === null || _this$_data20 === void 0 ? void 0 : _this$_data20.isCateringItem;
    }
  }, {
    key: "isAlcohol",
    get: function get() {
      var _this$selectedSKU2;

      return (_this$selectedSKU2 = this.selectedSKU) === null || _this$selectedSKU2 === void 0 ? void 0 : _this$selectedSKU2.isAlcohol;
    }
  }, {
    key: "alcoholSubClassification",
    get: function get() {
      var _this$selectedSKU3;

      return (_this$selectedSKU3 = this.selectedSKU) === null || _this$selectedSKU3 === void 0 ? void 0 : _this$selectedSKU3.alcoholSubClassification;
    }
  }, {
    key: "guestMsgWhenAlcoholNtAllowedInToGo",
    get: function get() {
      var _this$_data21;

      var successResponse = (_this$_data21 = this._data) === null || _this$_data21 === void 0 ? void 0 : _this$_data21.successResponse;
      return successResponse === null || successResponse === void 0 ? void 0 : successResponse.guestMsgWhenAlcoholNtAllowedInToGo;
    }
  }, {
    key: "availableDayTimePeriodInfo",
    get: function get() {
      var _this$_data22;

      var successResponse = (_this$_data22 = this._data) === null || _this$_data22 === void 0 ? void 0 : _this$_data22.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product.availableDayTimePeriodInfo;
    }
  }, {
    key: "menuId",
    get: function get() {
      var _this$_data23;

      var successResponse = (_this$_data23 = this._data) === null || _this$_data23 === void 0 ? void 0 : _this$_data23.successResponse;
      return successResponse.menuId;
    }
  }, {
    key: "validforlocation",
    get: function get() {
      var _this$_data24;

      var successResponse = (_this$_data24 = this._data) === null || _this$_data24 === void 0 ? void 0 : _this$_data24.successResponse;
      return successResponse.validforlocation;
    }
  }, {
    key: "isDisplayCourseForOrderAhead",
    get: function get() {
      var _this$_data25;

      var successResponse = (_this$_data25 = this._data) === null || _this$_data25 === void 0 ? void 0 : _this$_data25.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.displayCourseForOrderAhead;
    }
  }, {
    key: "alternateCourse",
    get: function get() {
      var _this$_data26;

      var successResponse = (_this$_data26 = this._data) === null || _this$_data26 === void 0 ? void 0 : _this$_data26.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.alternateCourse;
    }
  }, {
    key: "defaultCourse",
    get: function get() {
      var _this$_data27;

      var successResponse = (_this$_data27 = this._data) === null || _this$_data27 === void 0 ? void 0 : _this$_data27.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.defaultCourse;
    }
  }, {
    key: "seoMetaDescription",
    get: function get() {
      var _this$_data28;

      var successResponse = (_this$_data28 = this._data) === null || _this$_data28 === void 0 ? void 0 : _this$_data28.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.seoMetaDescription;
    }
  }, {
    key: "displayItemInstruction",
    get: function get() {
      var _this$_data29;

      var successResponse = (_this$_data29 = this._data) === null || _this$_data29 === void 0 ? void 0 : _this$_data29.successResponse;
      var product = successResponse === null || successResponse === void 0 ? void 0 : successResponse.product;
      return product === null || product === void 0 ? void 0 : product.displayItemInstruction;
    }
  }]);

  return MenuItemDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_skus", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_data", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "options", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markDirty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "markDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processSKUEntries", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processSKUEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pretty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pretty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMultiSku", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiSku"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedSKU", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedSKU"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "id", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keywords", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keywords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppSmallImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppSmallImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppLargeImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppLargeImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLunchPortion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLunchPortion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableAppImageAnimation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableAppImageAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultSelectedSku", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSelectedSku"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "longDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "longDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "legalDisclaimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legalDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "price", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "price"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skuPriceMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "skuPriceMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lowestPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lowestPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemTotalPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemTotalPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "indicators", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "indicators"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isToGo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isToGo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDineInOnly", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDineInOnly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isComplex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredMenuSkuBeansWithoutPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredMenuSkuBeansWithoutPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "greyOut", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "greyOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nutritionFacts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nutritionFacts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCateringItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCateringItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAlcohol", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAlcohol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alcoholSubClassification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alcoholSubClassification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guestMsgWhenAlcoholNtAllowedInToGo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "guestMsgWhenAlcoholNtAllowedInToGo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableDayTimePeriodInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableDayTimePeriodInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validforlocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validforlocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisplayCourseForOrderAhead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDisplayCourseForOrderAhead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alternateCourse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alternateCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultCourse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "seoMetaDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "seoMetaDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayItemInstruction", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayItemInstruction"), _class.prototype)), _class));
export { MenuItemDetail as default };
export function processRepositoryItem(repositoryItem) {
  var headingDefault = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.headingDefault;
  var displayName = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.displayName;
  var description = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.description;
  var isComboImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isComboImage;
  var id = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.id;
  var renderingOption = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.renderingOption;
  var isMultiSelect = renderingOption ? renderingOption === MenuTypes.IRenderingOption.CHECK_BOX ? true : false : false;
  var isMandatory = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isMandatory;
  var isCollapsible = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isCollapsible;
  var heading = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.heading;
  var isDynamicImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isDynamicImage;
  var isVisible = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isVisible;
  var displayNutrition = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.displayNutrition;
  var defaultDescription = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.descriptionDefault;
  var defaultDisplayName = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.displayNameDefault;
  var mobileAppImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.mobileAppImage;
  var defaultSelectedConfigOption = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.defaultSelectedConfigOption;
  var largeImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.largeImage;
  var smallImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.smallImage;
  var preparationTime = toInteger(repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.preparationTime, 0);
  var onlineOnly = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.onlineOnly;
  var isFoodItem = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isFoodItem;
  var menuCode = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.menuCode;
  var uom = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.unit_of_measure;
  var isAlcohol = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isAlcohol;
  var isModifier = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isModifier;
  var mobileAppLargeImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.mobileAppLargeImage;
  var winePairingIds = toStringArray(repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.winePairingIds);
  var mobileAppSmallImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.mobileAppSmallImage;
  var longDescription = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.longDescription;
  var maxCookTime = toInteger(repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.maxCookTime, 0);
  var isBeverageItem = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.isBeverageItem;
  var fdaMessage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.fdaMessage;
  var thumbnailImage = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.thumbnailImage;
  var showNutrition = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.showNutrition;
  var longDescriptionDefault = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.longDescriptionDefault;
  var listPrice = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.listPrice;
  var price = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.price;
  var portionSize = toInteger(repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.portionSize, -1);
  var adminDisplayName = repositoryItem === null || repositoryItem === void 0 ? void 0 : repositoryItem.adminDisplayName;
  return {
    headingDefault: headingDefault,
    displayName: displayName,
    description: description,
    isComboImage: isComboImage,
    id: id,
    renderingOption: renderingOption,
    isMultiSelect: isMultiSelect,
    isMandatory: isMandatory,
    isCollapsible: isCollapsible,
    heading: heading,
    isDynamicImage: isDynamicImage,
    isVisible: isVisible,
    displayNutrition: displayNutrition,
    defaultDescription: defaultDescription,
    defaultDisplayName: defaultDisplayName,
    mobileAppImage: mobileAppImage,
    largeImage: largeImage,
    smallImage: smallImage,
    preparationTime: preparationTime,
    onlineOnly: onlineOnly,
    isFoodItem: isFoodItem,
    menuCode: menuCode,
    uom: uom,
    isAlcohol: isAlcohol,
    isModifier: isModifier,
    mobileAppLargeImage: mobileAppLargeImage,
    winePairingIds: winePairingIds,
    mobileAppSmallImage: mobileAppSmallImage,
    longDescription: longDescription,
    maxCookTime: maxCookTime,
    isBeverageItem: isBeverageItem,
    fdaMessage: fdaMessage,
    thumbnailImage: thumbnailImage,
    showNutrition: showNutrition,
    longDescriptionDefault: longDescriptionDefault,
    listPrice: listPrice,
    price: price,
    portionSize: portionSize,
    defaultSelectedConfigOption: defaultSelectedConfigOption,
    adminDisplayName: adminDisplayName
  };
}